// extracted by mini-css-extract-plugin
export default {"user-preview-info":"UserPreviewInfo_user-preview-info__p58BR","user-preview-info__inner":"UserPreviewInfo_user-preview-info__inner__PA7kc"};